import React from "react";

export const PrjTitle: React.FC = ({ children }) => {
  return <h3 className="prj__content--title">{children}</h3>;
};
